import styled from '@emotion/styled';
import Dynamic from '@base/Dynamic/Dynamic';
import Loader from '@educator/Composite/QuestionCreation/Loader';
import Navigation from '../Navigation/Navigation';
import { WIDTH_MAX, WIDTH_MIN } from '../../constants';
import useLanding from './useLanding';

const Modals = Dynamic(() => import('@cont/Quiz/Taking/Modals'));
const ObjectiveQuestionView = Dynamic(() =>
  import('@cont/Quiz/Taking/Objective/QuestionView')
);
const SubjectiveQuestionView = Dynamic(() =>
  import('@cont/Quiz/Taking/Subjective/QuestionView')
);

const Wrapper = styled.div`
  min-width: ${WIDTH_MIN}px;
  max-width: ${WIDTH_MAX}px;
  height: 100vh;
  margin: auto;
  display: grid;
  grid-template-columns: 70% 30%;
  background-color: var(--color-base-0);
`;

const TakingLanding = () => {
  const { isSubjective, hasFetchedQuizQuestions } = useLanding();

  if (!hasFetchedQuizQuestions) {
    return <Loader />;
  }

  const renderQuestionView = () => {
    if (isSubjective) {
      return <SubjectiveQuestionView />;
    }

    return <ObjectiveQuestionView />;
  };

  return (
    <>
      <Wrapper>
        <div>{renderQuestionView()}</div>
        <Navigation />
      </Wrapper>
      <Modals />
    </>
  );
};

export default TakingLanding;
